import { render, staticRenderFns } from "./ProductDescDialog.vue?vue&type=template&id=78d2a750&scoped=true"
import script from "./ProductDescDialog.vue?vue&type=script&lang=js"
export * from "./ProductDescDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductDescDialog.vue?vue&type=style&index=0&id=78d2a750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d2a750",
  null
  
)

export default component.exports